export async function hash(
  input: any,
  algorithm: AlgorithmIdentifier = 'SHA-256'
) {
  const encoder = new TextEncoder();
  const data = encoder.encode(JSON.stringify(input, null, 2));
  const hashBuffer = await crypto.subtle.digest(algorithm, data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  return hashHex;
}
